import { createScale } from '../internal';
import type { VitalParameterBounds } from '../types';

export const pulseRateBounds: VitalParameterBounds = [
  {
    lower: 0,
    upper: 40,
    score: {
      type: 'low',
      value: 3,
    },
  },
  {
    lower: 41,
    upper: 50,
    score: {
      type: 'low',
      value: 1,
    },
  },
  {
    lower: 51,
    upper: 90,
    score: {
      type: 'normal',
      value: 0,
    },
  },
  {
    lower: 91,
    upper: 110,
    score: {
      type: 'high',
      value: 1,
    },
  },
  {
    lower: 111,
    upper: 130,
    score: {
      type: 'high',
      value: 2,
    },
  },
  {
    lower: 131,
    upper: Infinity,
    score: {
      type: 'high',
      value: 3,
    },
  },
];

/**
 * Pulse Rate (/min) `integer/min`
 */
export const pulseRate = createScale(pulseRateBounds, 0);
